<template>
  <p class="text-xs leading-5 text-black1 md:text-sm md:leading-6"><slot /></p>
</template>
